<template>
    <app-layout class="category-layout">
        <header class="category-header">
            <div class="row column"><slot name="header"></slot></div>
        </header>
        <div class="category-content">
            <slot></slot>
        </div>
    </app-layout>
</template>

<script>
    import AppLayout from './AppLayout.vue'

    export default {
        components: { AppLayout }
    }
</script>

<style lang="scss" scoped>
    @import "../../sass/settings";
    @import "../../sass/mixins";

    .category-header {
        padding-top: 35px;
        padding-bottom: 130px;
        background: url("../../images/polygon-bg.png") center center / cover;

        /deep/ h1 {
            color: white;
            font-size: px-em(30px);
            margin: 0.5rem 0 1rem 0;
        }
    }

    .category-content {
        margin-top: -130px;

        /deep/ .page-container {
            padding-top: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/layouts/CategoryLayout.vue